export default "__VITE_ASSET__BsNN3Gqi__"